import { Button, Stack, Typography } from '@mui/material';

interface Props {
  name: string;
  value: number;
  max: number;
  onChange: (next: number) => void;
}

// 44px targets: this is used one-handed on a phone.
const BTN = { minWidth: 44, height: 44, p: 0, fontSize: '1.25rem', lineHeight: 1 };

export default function SetCounter({ name, value, max, onChange }: Props) {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Button
        variant="outlined"
        size="small"
        sx={BTN}
        disabled={value <= 0}
        aria-label={`${name}: odejmij seta`}
        onClick={() => onChange(value - 1)}
      >−</Button>
      <Typography
        component="span"
        sx={{ minWidth: 28, textAlign: 'center', fontSize: '1.25rem', fontWeight: 500 }}
      >{value}</Typography>
      <Button
        variant="outlined"
        size="small"
        sx={BTN}
        disabled={value >= max}
        aria-label={`${name}: dodaj seta`}
        onClick={() => onChange(value + 1)}
      >+</Button>
    </Stack>
  );
}
